import type { JSX } from "react";

import { CustomerLocationView } from "./CustomerLocationView";
import { useCustomerLocationData } from "./useCustomerLocationData";

export function CustomerLocation(): JSX.Element | null {
    const { shouldRender, viewProps } = useCustomerLocationData();

    if (!shouldRender || !viewProps) {
        return null;
    }

    return <CustomerLocationView {...viewProps} />;
}
